import { useEffect, useState } from 'react';
import { Cradle } from '@solo/app-core';
import { translate } from '@/app/i18n';
import Colors from '@/app/styles/Colors';
import { Flex, LoadingComponent, SubscriptionCard, Text } from '@/app/ui';
import { useCradle } from '@/app/contexts';
import type { SubscriptionInfo } from '@/app/ui/organisms/SubscriptionCard/SubscriptionCard';

interface SubscriptionTypeSelectComponentProps {
  setSelectedSubscription: (subscription: SubscriptionInfo, priceId?: string) => void;
  className?: string;
}
const SubscriptionTypeSelectComponent = ({
  setSelectedSubscription,
  className,
}: SubscriptionTypeSelectComponentProps) => {
  const { paymentBloc } = useCradle<Cradle>();
  const [products, setProducts] = useState<SubscriptionInfo[]>([]);
  const [loading, setLoading] = useState(true);

  async function getProducts() {
    const prices = await paymentBloc.getStripePriceProducts();

    const productsList: any[] = [];
    prices.forEach((price) => {
      if (!price.active || !price.product.active) return;
      const productExist = productsList.find((p) => p.id === price.product.id);

      if (!productExist) {
        productsList.push({
          id: price.product.id,
          title: price.product.name,
          description: price.product.description,
          prices: [
            {
              priceId: price.id,
              price: price.unit_amount / 100,
              interval: price.recurring.interval,
              intervalCount: price.recurring.interval_count,
            },
          ],
        });
      } else {
        productExist.prices.push({
          priceId: price.id,
          price: price.unit_amount / 100,
          interval: price.recurring.interval,
          intervalCount: price.recurring.interval_count,
        });
      }
    });
    setLoading(false);
    setProducts(productsList);
  }

  useEffect(() => {
    getProducts();
  }, []);

  return (
    <Flex.Container
      flexDirection="column"
      gap="2rem"
      style={{ width: '100%' }}
      className={className}
    >
      <Text.Title2 style={{ color: Colors.white, paddingLeft: '10rem' }} className="mt-2 mb-2">
        {translate('SIGN_UP.CHOOSE_THE_BEST_SUBSCRIPTION')}
      </Text.Title2>
      {loading ? (
        <LoadingComponent />
      ) : (
        <Flex.Container>
          <Flex.Container gap="15px" style={{ width: '100%' }}>
            {products.map((product) => (
              <Flex.Item flex={1} key={product.title}>
                <SubscriptionCard
                  info={product}
                  select={(priceId) =>
                    setSelectedSubscription({ ...product, priceId: priceId || '' })
                  }
                />
              </Flex.Item>
            ))}
          </Flex.Container>
        </Flex.Container>
      )}
    </Flex.Container>
  );
};
export default SubscriptionTypeSelectComponent;
